module.exports = __webpack_public_path__ + "static/media/petrobras.1bb8259a.png";